/* Central English to Hindi translation catalogue. */
export const HI_TRANSLATIONS = {
  "Loading dashboard...": "डैशबोर्ड लोड हो रहा है...",
  "Dashboard session not found.": "डैशबोर्ड सत्र नहीं मिला।",
  "Back to Home": "होम पर वापस जाएं",
  Notifications: "सूचनाएं",
  Messages: "संदेश",
  "My Tasks": "मेरे कार्य",
  "Avg Completion": "औसत पूर्णता",
  KaamScore: "कामस्कोर",
  "Current score": "वर्तमान स्कोर",
  "Active Staff Today": "आज सक्रिय कर्मचारी",
  "Tasks Assigned": "सौंपे गए कार्य",
  "From completed tasks": "पूर्ण किए गए कार्यों से",
  "Pending Leaves": "लंबित अवकाश",
  "Needs approval": "अनुमोदन आवश्यक है",
  "KaamScore - Top": "कामस्कोर - शीर्ष",
  "No top user yet": "अभी कोई शीर्ष उपयोगकर्ता नहीं है",
  "Department Progress - Today": "विभागीय प्रगति - आज",
  "Business Type": "व्यवसाय प्रकार",
  City: "शहर",
  Plan: "योजना",
  Invoice: "चालान",
  "Not saved": "सहेजा नहीं गया",
  Trial: "परीक्षण अवधि",
  "Not generated": "तैयार नहीं हुआ",
  "days left": "दिन शेष",
  members: "सदस्य",
  "plan active": "योजना सक्रिय है",
  "All plan features are active during your trial.":
    "आपकी परीक्षण अवधि के दौरान योजना की सभी सुविधाएं सक्रिय हैं।",
  "member slots are currently used.":
    "सदस्य स्लॉट वर्तमान में उपयोग किए जा रहे हैं।",
  "Upgrade now": "अभी अपग्रेड करें",
  "Manage plan": "योजना प्रबंधित करें",
  "Active employees": "सक्रिय कर्मचारी",
  "Tasks today": "आज के कार्य",
  "Attendance today": "आज की उपस्थिति",
  "Leave requests": "अवकाश अनुरोध",
  "assigned across team": "पूरी टीम में सौंपे गए",
  "pending your review": "आपकी समीक्षा के लिए लंबित",
  "Action needed": "कार्रवाई आवश्यक है",
  "Up to date": "अद्यतन है",
  "Today’s Tasks SnapShot": "आज के कार्यों का सारांश",
  "View all tasks →": "सभी कार्य देखें →",
  Pending: "लंबित",
  "In progress": "प्रगति में",
  Verified: "सत्यापित",
  "Department completion rate — today": "विभाग पूर्णता दर — आज",
  "No departments have been added yet.": "अभी तक कोई विभाग नहीं जोड़ा गया है।",
  "Setup checklist": "सेटअप सूची",
  done: "पूर्ण",
  Done: "पूर्ण",
  "Quick actions": "त्वरित कार्रवाइयां",
  "Assign new task": "नया कार्य सौंपें",
  "Add team member": "टीम सदस्य जोड़ें",
  "Send announcement": "घोषणा भेजें",
  "Export report": "रिपोर्ट निर्यात करें",
  "Add department": "विभाग जोड़ें",
  "Billing portal": "बिलिंग पोर्टल",
  Activity: "गतिविधि",
  new: "नया",
  "No recent activity.": "हाल की कोई गतिविधि नहीं है।",
  "Assign Task": "कार्य सौंपें",
  "Create a task and assign it to active employees":
    "एक कार्य बनाएं और इसे सक्रिय कर्मचारियों को सौंपें",
  "Task Title": "कार्य शीर्षक",
  Manager: "प्रबंधक",
  Me: "मैं",
  "Select manager": "प्रबंधक चुनें",
  Employee: "कर्मचारी",
  "Select employee": "कर्मचारी चुनें",
  "Task Deadline": "कार्य की अंतिम तिथि",
  Priority: "प्राथमिकता",
  Low: "कम",
  Medium: "मध्यम",
  High: "उच्च",
  Urgent: "अत्यावश्यक",
  Description: "विवरण",
  "Task details...": "कार्य विवरण...",
  "TO DO": "करना है",
  "IN PROGRESS": "प्रगति में",
  "IN REVIEW": "समीक्षा में",
  DONE: "पूर्ण",
  "No tasks.": "कोई कार्य नहीं है।",
  "Task title": "कार्य शीर्षक",
  "No notes": "कोई नोट नहीं",
  "Not set": "निर्धारित नहीं",
  "No deadline": "कोई अंतिम तिथि नहीं",
  Deadline: "अंतिम तिथि",
  by: "द्वारा",
  Progress: "प्रगति",
  "Progress/completion note": "प्रगति/पूर्णता नोट",
  "Complete Task": "कार्य पूर्ण करें",
  "Update Progress": "प्रगति अपडेट करें",
  "Start Task": "कार्य शुरू करें",
  "Starting...": "शुरू हो रहा है...",
  "Open Work": "कार्य खोलें",
  "Hide Work Details": "कार्य विवरण छिपाएं",
  "Saving...": "सहेजा जा रहा है...",
  Approved: "अनुमोदित करें",
  Reopen: "पुनः खोलें",
  "Save Edit/Shift": "संपादन/शिफ्ट सहेजें",
  Cancel: "रद्द करें",
  "Edit / Shift": "संपादित करें / शिफ्ट",
  Delete: "हटाएं",
  "My Team": "मेरी टीम",
  "Team Management": "टीम प्रबंधन",
  "Assign employees to managers and manage team members":
    "कर्मचारियों को प्रबंधकों को सौंपें और टीम सदस्यों का प्रबंधन करें",
  "Track employees assigned under you":
    "अपने अंतर्गत सौंपे गए कर्मचारियों को ट्रैक करें",
  "Invite via WhatsApp": "WhatsApp के माध्यम से आमंत्रित करें",
  "Add Manually": "मैन्युअल रूप से जोड़ें",
  "Invite role": "भूमिका आमंत्रण",
  "Send Invite": "आमंत्रण भेजें",
  "All Members": "सभी सदस्य",
  Managers: "प्रबंधक",
  Employees: "कर्मचारी",
  "Export Excel": "Excel निर्यात करें",
  "Assign employee to manager": "कर्मचारी को प्रबंधक को सौंपें",
  "Select employee and manager, then assign/update instantly.":
    "कर्मचारी और प्रबंधक चुनें, फिर तुरंत असाइन/अपडेट करें।",
  Update: "अपडेट करें",
  Assign: "सौंपें",
  "Select date and member to review attendance records":
    "उपस्थिति रिकॉर्ड देखने के लिए तारीख और सदस्य चुनें",
  "Team member": "टीम सदस्य",
  "All visible members": "सभी दिखाई देने वाले सदस्य",
  Date: "तारीख",
  "Check-in is saved once, when the user logs in.":
    "उपयोगकर्ता के लॉगिन करने पर चेक-इन एक बार सहेजा जाता है।",
  "Attendance Log": "उपस्थिति लॉग",
  records: "रिकॉर्ड",
  "Location not saved": "स्थान सहेजा नहीं गया",
  "View map": "मानचित्र देखें",
  "No attendance found for the selected filters.":
    "चुने गए फ़िल्टर के लिए कोई उपस्थिति नहीं मिली।",
  "No check-in": "कोई चेक-इन नहीं",
  "Apply Leave": "अवकाश आवेदन करें",
  "Leave Requests": "अवकाश अनुरोध",
  "Pending approvals and history": "लंबित अनुमोदन और इतिहास",
  "CL Available": "CL उपलब्ध",
  "SL Available": "SL उपलब्ध",
  "EL Available": "EL उपलब्ध",
  used: "उपयोग किया गया",
  "New Leave Application": "नया अवकाश आवेदन",
  "Leave Type": "अवकाश प्रकार",
  "Casual Leave": "आकस्मिक अवकाश",
  "Sick Leave": "बीमारी अवकाश",
  "Earned Leave": "अर्जित अवकाश",
  "Half Day - AM": "आधा दिन - पूर्वाह्न",
  "Half Day - PM": "आधा दिन - अपराह्न",
  "Work from Home": "घर से काम",
  "Start Date": "प्रारंभ तिथि",
  "End Date": "समाप्ति तिथि",
  Reason: "कारण",
  "Reason for leave (max 300 chars)...": "अवकाश का कारण (अधिकतम 300 अक्षर)...",
  "My Leave History": "मेरा अवकाश इतिहास",
  "All Leave Requests": "सभी अवकाश अनुरोध",
  "My Leave": "मेरा अवकाश",
  to: "तक",
  Reject: "अस्वीकार करें",
  "No leave records.": "कोई अवकाश रिकॉर्ड नहीं है।",
  Analytics: "विश्लेषण",
  "Business health overview": "व्यवसाय स्वास्थ्य अवलोकन",
  Tasks: "कार्य",
  "Total assigned": "कुल सौंपे गए",
  Completion: "पूर्णता",
  "Current average": "वर्तमान औसत",
  Attendance: "उपस्थिति",
  "Present today": "आज उपस्थित",
  "Department Analytics": "विभागीय विश्लेषण",
  "Billing & Subscription": "बिलिंग और सदस्यता",
  "Plan and invoice details": "योजना और चालान विवरण",
  Payment: "भुगतान",
  Status: "स्थिति",
  Settings: "सेटिंग्स",
  "Company profile": "कंपनी प्रोफाइल",
  Company: "कंपनी",
  "Owner Email": "मालिक का ईमेल",
  Mobile: "मोबाइल",
  GSTIN: "GSTIN",
  "Not provided": "उपलब्ध नहीं कराया गया",
  "KaamScore - Team Leaderboard": "कामस्कोर - टीम लीडरबोर्ड",
  "Team performance": "टीम प्रदर्शन",
  "points · task and attendance score": "अंक · कार्य और उपस्थिति स्कोर",
  Gold: "स्वर्ण",
  Silver: "रजत",
  "My KaamScore": "मेरा कामस्कोर",
  "Progress this month": "इस महीने की प्रगति",
  "tasks done": "पूर्ण किए गए कार्य",
  completion: "पूर्णता",
  "Daily Report": "दैनिक रिपोर्ट",
  Announcement: "घोषणा",
  "Submit your work summary": "अपना कार्य सारांश जमा करें",
  "Completed Today": "आज पूर्ण किया गया",
  "What did you complete today?": "आज आपने क्या पूरा किया?",
  Blockers: "बाधाएं",
  "Any blockers?": "कोई बाधा है?",
  "Submit Report": "रिपोर्ट जमा करें",
  "View all": "सभी देखें",
  "No notifications yet.": "अभी कोई सूचना नहीं है।",
  "in review": "समीक्षा में",
  "active users": "सक्रिय उपयोगकर्ता",
  completed: "पूर्ण",
  "not marked": "चिह्नित नहीं",
  "this week": "इस सप्ताह",
  across: "में",
  departments: "विभाग",
  of: "का",
  "team members": "टीम सदस्य",
  "Loading...": "लोड हो रहा है...",
  "Loading…": "लोड हो रहा है…",
  "Loading settings…": "सेटिंग्स लोड हो रही हैं…",
  English: "अंग्रेज़ी",
  Hindi: "हिंदी",
  Language: "भाषा",
  Features: "सुविधाएं",
  Pricing: "मूल्य निर्धारण",
  Login: "लॉगिन",
  Logout: "लॉगआउट",
  Dashboard: "डैशबोर्ड",
  "Company Profile": "कंपनी प्रोफाइल",
  "Owner Profile": "मालिक प्रोफाइल",
  "Open profile menu": "प्रोफाइल मेनू खोलें",
  "Settings sections": "सेटिंग्स अनुभाग",
  "Working hours": "कार्य घंटे",
  "Owner profile": "मालिक प्रोफाइल",
  "Danger zone": "खतरे का क्षेत्र",
  "Company logo": "कंपनी लोगो",
  "Company information": "कंपनी की जानकारी",
  "Company name": "कंपनी का नाम",
  "Business type": "व्यवसाय प्रकार",
  "GST number": "GST नंबर",
  optional: "वैकल्पिक",
  "Billing email": "बिलिंग ईमेल",
  "Upload new logo": "नया लोगो अपलोड करें",
  Remove: "हटाएं",
  "Save company info": "कंपनी जानकारी सहेजें",
  "PNG or JPG, under 2MB. Appears on dashboards, invoices, and reports.":
    "PNG या JPG, 2MB से कम। यह डैशबोर्ड, चालान और रिपोर्ट में दिखाई देगा।",
  "Default working hours": "डिफॉल्ट कार्य घंटे",
  "Apply to all departments": "सभी विभागों पर लागू करें",
  "These defaults already apply company-wide.":
    "ये डिफॉल्ट पहले से पूरी कंपनी पर लागू हैं।",
  "These are company-wide defaults. Individual departments can override these in the Departments screen.":
    "ये पूरी कंपनी के डिफॉल्ट हैं। अलग-अलग विभाग इन्हें विभाग स्क्रीन में बदल सकते हैं।",
  "WORKING HOURS": "कार्य घंटे",
  "Start time": "प्रारंभ समय",
  "End time": "समाप्ति समय",
  "Late-mark grace": "देर से आने की छूट",
  "Staff marked late after this buffer":
    "इस समय सीमा के बाद स्टाफ को देर से आने वाला माना जाएगा",
  Timezone: "समय क्षेत्र",
  "Default working days": "डिफॉल्ट कार्य दिवस",
  "Save working hours": "कार्य घंटे सहेजें",
  "Language and display": "भाषा और डिस्प्ले",
  "Interface language": "इंटरफेस भाषा",
  "All screens in English": "सभी स्क्रीन अंग्रेज़ी में",
  "Mixed Hindi & English": "हिंदी और अंग्रेज़ी मिश्रित",
  "Date format": "तारीख प्रारूप",
  "Currency display": "मुद्रा प्रदर्शन",
  "Save preferences": "प्राथमिकताएं सहेजें",
  "Your profile": "आपकी प्रोफाइल",
  "Full name": "पूरा नाम",
  "Mobile number": "मोबाइल नंबर",
  Email: "ईमेल",
  Designation: "पद",
  "Save profile": "प्रोफाइल सहेजें",
  "Upload photo": "फोटो अपलोड करें",
  "Export all company data": "कंपनी का पूरा डेटा निर्यात करें",
  "Export data": "डेटा निर्यात करें",
  "Suspend all team access": "पूरी टीम की पहुंच रोकें",
  "Suspend team": "टीम निलंबित करें",
  "Delete company account": "कंपनी खाता हटाएं",
  "Delete account": "खाता हटाएं",
  "Saved successfully.": "सफलतापूर्वक सहेजा गया।",
  "Upload a PNG or JPG image under 2MB.":
    "2MB से कम PNG या JPG इमेज अपलोड करें।",
  Search: "खोजें",
  "Search...": "खोजें...",
  Submit: "जमा करें",
  Save: "सहेजें",
  Close: "बंद करें",
  Edit: "संपादित करें",
  View: "देखें",
  Download: "डाउनलोड करें",
  Upload: "अपलोड करें",
  Continue: "जारी रखें",
  Back: "वापस",
  Next: "अगला",
  Previous: "पिछला",
  Confirm: "पुष्टि करें",
  Yes: "हाँ",
  No: "नहीं",
  Name: "नाम",
  Role: "भूमिका",
  Department: "विभाग",
  Actions: "कार्रवाई",
  Action: "कार्रवाई",
  Title: "शीर्षक",
  Phone: "फोन",
  Address: "पता",
  Password: "पासवर्ड",
  "Confirm Password": "पासवर्ड की पुष्टि करें",
  Required: "आवश्यक",
  "This field is required.": "यह फ़ील्ड आवश्यक है।",
  "Invalid email address.": "अमान्य ईमेल पता।",
  "Something went wrong.": "कुछ गलत हो गया।",
  "Error while processing your request":
    "आपके अनुरोध को संसाधित करते समय त्रुटि हुई।",
  "No data found.": "कोई डेटा नहीं मिला।",
  "No records found.": "कोई रिकॉर्ड नहीं मिला।",
  Home: "होम",
  Signup: "साइन अप",
  Register: "रजिस्टर करें",
  "Register Company": "कंपनी रजिस्टर करें",
  "Start for ₹9": "₹9 से शुरू करें",
  "Welcome back": "वापसी पर स्वागत है",
  "Sign in": "साइन इन करें",
  "Create account": "खाता बनाएं",
  "Forgot password?": "पासवर्ड भूल गए?",
  Announcements: "घोषणाएं",
  Reports: "रिपोर्ट",
  Billing: "बिलिंग",
  Team: "टीम",
  Leaves: "अवकाश",
  Companies: "कंपनियां",
  Logs: "लॉग्स",
  Bugs: "बग्स",
  "Super Admin": "सुपर एडमिन",
  PLATFORM: "प्लेटफ़ॉर्म",
  FINANCE: "वित्त",
  ADMIN: "एडमिन",
  Revenue: "राजस्व",
  "WhatsApp usage": "WhatsApp उपयोग",
  "Admin users": "एडमिन उपयोगकर्ता",
  "Audit log": "ऑडिट लॉग",
  Fraud: "धोखाधड़ी",
  "AI command": "AI कमांड",
};

/* Phrase fragments used for dynamic counts and API-provided UI messages. */
export const HI_PHRASE_TRANSLATIONS = Object.freeze({
  "Growth plan active": "ग्रोथ प्लान सक्रिय है",
  "member slots are currently used": "सदस्य स्लॉट वर्तमान में उपयोग में हैं",
  members: "सदस्य",
  "AI Generated Summary": "AI द्वारा तैयार सारांश",
  "ACTIVE EMPLOYEES": "सक्रिय कर्मचारी",
  "across departments": "विभागों में",
  "this week": "इस सप्ताह",
  "TASKS TODAY": "आज के कार्य",
  "assigned across team": "पूरी टीम में सौंपे गए",
  completed: "पूर्ण",
  "ATTENDANCE TODAY": "आज की उपस्थिति",
  "of team members": "टीम सदस्यों में से",
  "not marked": "दर्ज नहीं",
  "LEAVE REQUESTS": "अवकाश अनुरोध",
  "pending your review": "आपकी समीक्षा के लिए लंबित",
  "Up to date": "अद्यतन",
  "Today's task snapshot": "आज के कार्यों का सारांश",
  "Today’s task snapshot": "आज के कार्यों का सारांश",
  "View all tasks": "सभी कार्य देखें",
  "Department completion rate": "विभाग पूर्णता दर",
  "Quick actions": "त्वरित कार्रवाइयां",
  "Assign new task": "नया कार्य सौंपें",
  "Add team member": "टीम सदस्य जोड़ें",
  "Send announcement": "घोषणा भेजें",
  "Export report": "रिपोर्ट निर्यात करें",
  "Add department": "विभाग जोड़ें",
  "Billing portal": "बिलिंग पोर्टल",
  "Company registered and payment confirmed":
    "कंपनी पंजीकृत और भुगतान की पुष्टि हो गई",
  "Add your first department": "अपना पहला विभाग जोड़ें",
  "Invite your first team member": "अपने पहले टीम सदस्य को आमंत्रित करें",
  "Assign your first task": "अपना पहला कार्य सौंपें",
  Main: "मुख्य",
  "Tasks / Work": "कार्य",
  "Leave requests": "अवकाश अनुरोध",
  Company: "कंपनी",
  Account: "खाता",
  Reports: "रिपोर्ट",
  Billing: "बिलिंग",
  Settings: "सेटिंग्स",
  "Plan manage": "प्लान प्रबंधित करें",
  "Manage plan": "प्लान प्रबंधित करें",
  "Dashboard overview": "डैशबोर्ड अवलोकन",
  "Manager dashboard overview": "मैनेजर डैशबोर्ड अवलोकन",
  "Employee dashboard overview": "कर्मचारी डैशबोर्ड अवलोकन",
  "All members": "सभी सदस्य",
  "All departments": "सभी विभाग",
  "All projects": "सभी प्रोजेक्ट",
  "All priorities": "सभी प्राथमिकताएं",
  "All statuses": "सभी स्थितियां",
  "All industries": "सभी उद्योग",
  "All cities": "सभी शहर",
  "All plans": "सभी प्लान",
  "All severities": "सभी गंभीरताएं",
  "Apply filters": "फ़िल्टर लागू करें",
  "Clear filters": "फ़िल्टर हटाएं",
  "Newest first": "नवीनतम पहले",
  "Oldest first": "सबसे पुराने पहले",
  "No tasks found": "कोई कार्य नहीं मिला",
  "No records found for the selected filters":
    "चुने गए फ़िल्टर के लिए कोई रिकॉर्ड नहीं मिला",
  "No companies found": "कोई कंपनी नहीं मिली",
  "No notifications found": "कोई सूचना नहीं मिली",
  "No announcements available": "कोई घोषणा उपलब्ध नहीं है",
  "No logs found for the selected filters":
    "चुने गए फ़िल्टर के लिए कोई लॉग नहीं मिला",
  "No bugs found for the selected filters":
    "चुने गए फ़िल्टर के लिए कोई बग नहीं मिला",
  "No invoices available yet": "अभी कोई चालान उपलब्ध नहीं है",
  "No payment history found": "कोई भुगतान इतिहास नहीं मिला",
  "No pending leave requests": "कोई लंबित अवकाश अनुरोध नहीं है",
  "No tasks assigned for today": "आज के लिए कोई कार्य नहीं सौंपा गया",
  "No team members yet": "अभी कोई टीम सदस्य नहीं है",
  "Loading announcements": "घोषणाएं लोड हो रही हैं",
  "Loading notifications": "सूचनाएं लोड हो रही हैं",
  "Loading report data": "रिपोर्ट डेटा लोड हो रहा है",
  "Loading platform logs": "प्लेटफ़ॉर्म लॉग लोड हो रहे हैं",
  "Loading bug monitoring data": "बग मॉनिटरिंग डेटा लोड हो रहा है",
  "Platform data loading": "प्लेटफ़ॉर्म डेटा लोड हो रहा है",
  "Mark all read": "सभी को पढ़ा हुआ चिह्नित करें",
  "Previous page": "पिछला पृष्ठ",
  "Next page": "अगला पृष्ठ",
  Page: "पृष्ठ",
  "Search by name, email or mobile": "नाम, ईमेल या मोबाइल से खोजें",
  "Search companies": "कंपनियां खोजें",
  "Search tasks": "कार्य खोजें",
  "Search notifications": "सूचनाएं खोजें",
  "Search logs": "लॉग खोजें",
  "Search bugs": "बग खोजें",
  "Attendance filters": "उपस्थिति फ़िल्टर",
  "Notification filters": "सूचना फ़िल्टर",
  "Task filters": "कार्य फ़िल्टर",
  "Date from": "आरंभ तिथि",
  "Date to": "अंतिम तिथि",
  "From date": "आरंभ तिथि",
  "To date": "अंतिम तिथि",
  "Select date": "तिथि चुनें",
  "Select role": "भूमिका चुनें",
  "Select department": "विभाग चुनें",
  "Select member": "सदस्य चुनें",
  "Select status": "स्थिति चुनें",
  "Select priority": "प्राथमिकता चुनें",
  "Select project": "प्रोजेक्ट चुनें",
  "Select leave type": "अवकाश प्रकार चुनें",
  "Please select": "कृपया चुनें",
  "Please wait": "कृपया प्रतीक्षा करें",
  "Processing your payment": "आपका भुगतान संसाधित किया जा रहा है",
  "Please complete all required details and accept the terms":
    "कृपया सभी आवश्यक विवरण भरें और शर्तों को स्वीकार करें",
  "Please enter the 6-digit OTP": "कृपया 6 अंकों का OTP दर्ज करें",
  "OTP expired. Please resend the code":
    "OTP समाप्त हो गया है। कृपया कोड दोबारा भेजें",
  "A valid company ID is required": "मान्य कंपनी ID आवश्यक है",
  "Announcement message is required": "घोषणा संदेश आवश्यक है",
  "Please allow pop-ups to export this report":
    "इस रिपोर्ट को निर्यात करने के लिए पॉप-अप की अनुमति दें",
  "Saved successfully": "सफलतापूर्वक सहेजा गया",
  "Updated successfully": "सफलतापूर्वक अपडेट किया गया",
  "Deleted successfully": "सफलतापूर्वक हटाया गया",
  "Sent successfully": "सफलतापूर्वक भेजा गया",
  "Something went wrong": "कुछ गलत हो गया",
  "Unable to load": "लोड करने में असमर्थ",
  "Try again": "फिर प्रयास करें",
  Refresh: "रीफ्रेश करें",
  Open: "खोलें",
  "View details": "विवरण देखें",
  "Change details": "विवरण बदलें",
  "Choose your plan": "अपना प्लान चुनें",
  "Choose your plan after trial": "ट्रायल के बाद अपना प्लान चुनें",
  "Activate plan": "प्लान सक्रिय करें",
  "Cancel subscription": "सदस्यता रद्द करें",
  "Auto-renew enabled": "स्वतः नवीनीकरण सक्रिय है",
  "Auto-renewal": "स्वतः नवीनीकरण",
  "Current plan": "वर्तमान प्लान",
  "Billing details": "बिलिंग विवरण",
  "Payment method": "भुगतान विधि",
  "Payment history": "भुगतान इतिहास",
  "Owner details": "मालिक का विवरण",
  "Admin actions": "एडमिन कार्रवाइयां",
  "Internal notes": "आंतरिक नोट्स",
  "Add note": "नोट जोड़ें",
  "Add a private note about this company":
    "इस कंपनी के बारे में निजी नोट जोड़ें",
  "No internal notes": "कोई आंतरिक नोट नहीं",
  "Company details": "कंपनी विवरण",
  "Platform statistics": "प्लेटफ़ॉर्म आंकड़े",
  "Recent platform activity": "हाल की प्लेटफ़ॉर्म गतिविधि",
  "System health": "सिस्टम स्वास्थ्य",
  "Active users now": "अभी सक्रिय उपयोगकर्ता",
  "Paid plans": "भुगतान वाले प्लान",
  "Active trials": "सक्रिय ट्रायल",
  "Monthly churn": "मासिक ग्राहक हानि",
  "API response": "API प्रतिक्रिया",
  "API error rate": "API त्रुटि दर",
  "Ask AI": "AI से पूछें",
  "Open AI command": "AI कमांड खोलें",
  "Close AI Saathi": "AI साथी बंद करें",
  "Ask about attendance, leave or tasks":
    "उपस्थिति, अवकाश या कार्यों के बारे में पूछें",
  "Task title": "कार्य शीर्षक",
  "Assigned by": "सौंपने वाला",
  "Assigned on": "सौंपने की तिथि",
  Assignee: "जिम्मेदार व्यक्ति",
  Attachments: "संलग्नक",
  "Add a comment": "टिप्पणी जोड़ें",
  "Add a note to this update": "इस अपडेट में नोट जोड़ें",
  "No attachments submitted": "कोई संलग्नक जमा नहीं किया गया",
  "Approve task": "कार्य स्वीकृत करें",
  "Complete task": "कार्य पूर्ण करें",
  "Reopen task": "कार्य दोबारा खोलें",
  "Start task": "कार्य शुरू करें",
  "Update progress": "प्रगति अपडेट करें",
  "Work details": "कार्य विवरण",
  "Leave history": "अवकाश इतिहास",
  "Leave details": "अवकाश विवरण",
  "Leave approvals": "अवकाश अनुमोदन",
  "Apply for leave": "अवकाश के लिए आवेदन करें",
  "Balance after": "बाद में शेष",
  "Supporting document": "सहायक दस्तावेज़",
  "No supporting document attached": "कोई सहायक दस्तावेज़ संलग्न नहीं है",
  "All team leave requests have been reviewed":
    "टीम के सभी अवकाश अनुरोधों की समीक्षा हो चुकी है",
  "Your profile": "आपकी प्रोफाइल",
  "Profile image": "प्रोफाइल चित्र",
  "Optional profile image upload": "वैकल्पिक प्रोफाइल चित्र अपलोड",
  "Change email/mobile": "ईमेल/मोबाइल बदलें",
  "Privacy Policy": "गोपनीयता नीति",
  "Terms and Conditions": "नियम और शर्तें",
  "Forgot Password": "पासवर्ड भूल गए",
  "Reset Password": "पासवर्ड रीसेट करें",
  "Send reset link": "रीसेट लिंक भेजें",
  "Create new password": "नया पासवर्ड बनाएं",
  "Password reset successfully": "पासवर्ड सफलतापूर्वक रीसेट हुआ",
  "Back to login": "लॉगिन पर वापस जाएं",
  "Mobile navigation": "मोबाइल नेविगेशन",
  "Open menu": "मेनू खोलें",
  "Close menu": "मेनू बंद करें",
  "Footer navigation": "फुटर नेविगेशन",
  Copyright: "कॉपीराइट",
  "All rights reserved": "सर्वाधिकार सुरक्षित",
  "Registration complete": "पंजीकरण पूरा हुआ",
  "Finishing up": "अंतिम चरण",
  "Step 2 of 5": "चरण 2 / 5",
  "Step 3 of 5": "चरण 3 / 5",
  "Step 4 of 5": "चरण 4 / 5",
  "Verify your email": "अपना ईमेल सत्यापित करें",
  "We sent a 6-digit code to": "हमने 6 अंकों का कोड इस ईमेल पर भेजा है:",
  "Enter it below to secure your owner account.": "अपने मालिक खाते को सुरक्षित करने के लिए नीचे कोड दर्ज करें।",
  "Email OTP sent to": "ईमेल ओटीपी भेजा गया:",
  "Testing Email OTP:": "परीक्षण ईमेल ओटीपी:",
  "Enter the 6-digit code": "6 अंकों का कोड दर्ज करें",
  "Expires in": "समय शेष",
  "Resend code": "कोड फिर भेजें",
  "Verify and continue": "सत्यापित करके आगे बढ़ें",
  "Use a different email": "दूसरा ईमेल इस्तेमाल करें",
  "Start with the ₹9 Pehchaan trial — all Growth features for 30 days, no restrictions. Upgrade anytime, cancel anytime.": "₹9 पहचान ट्रायल से शुरू करें — 30 दिनों तक ग्रोथ प्लान की सभी सुविधाएं पाएं। आप कभी भी अपग्रेड या रद्द कर सकते हैं।",
  "Continue to payment": "भुगतान के लिए आगे बढ़ें",
  "Mock secure payment · UPI, Card, Net Banking accepted": "सुरक्षित परीक्षण भुगतान · यूपीआई, कार्ड और नेट बैंकिंग स्वीकार हैं",
  "Select a payment method and complete the mock payment for your": "भुगतान का तरीका चुनें और अपनी योजना के लिए परीक्षण भुगतान पूरा करें।",
  "Total payable": "कुल देय राशि",
  "Including 18% GST": "18% जीएसटी सहित",
  "Do not close this window. Your mock transaction will complete in 5 seconds.": "इस विंडो को बंद न करें। आपका परीक्षण लेन-देन 5 सेकंड में पूरा हो जाएगा।",
  "Transaction Successful": "लेन-देन सफल रहा",
  "Payment ID": "भुगतान आईडी",
  "Add Department": "विभाग जोड़ें",
  "Add Manager": "प्रबंधक जोड़ें",
  "Add Employee": "कर्मचारी जोड़ें",
  "Select Department": "विभाग चुनें",
  "Other Department Name": "अन्य विभाग का नाम",
  "Enter department name": "विभाग का नाम दर्ज करें",
  "Enter manager name": "प्रबंधक का नाम दर्ज करें",
  "Enter employee name": "कर्मचारी का नाम दर्ज करें",
  "Invite & Continue": "आमंत्रित करें और आगे बढ़ें",
  "Sending Invitation...": "आमंत्रण भेजा जा रहा है...",
});

/* Complete public authentication-page copy. These values are rendered directly by
 * Login and Registration so a language switch never creates word-by-word text. */
export const AUTH_PAGE_COPY = {
  login: {
    en: {
      securityBadge: "SIMPLE, SECURE, PASSWORD LOGIN",
      heroTitleOne: "One secure sign-in.", heroTitleTwo: "Zero friction.",
      heroCopy: "Use your registered email or mobile number and password to get back to your workday.",
      flowOneTitle: "Enter your email or mobile", flowOneCopy: "Use the contact saved on your account",
      flowTwoTitle: "Enter your password", flowTwoCopy: "Your password is securely hashed",
      flowThreeTitle: "Open your workspace", flowThreeCopy: "Pick up exactly where you left off",
      privacyTitle: "Your privacy comes first", privacyCopy: "Protected access, every time.",
      login: "LOG IN", welcome: "Welcome back", loginCopy: "Sign in with your registered email/mobile number and password.",
      identifier: "Email or mobile number", password: "Password", forgotPassword: "Forgot password?", loggingIn: "Logging in...",
      newUser: "New to KaamDesk?", register: "Register your company", validIdentifier: "Please enter a valid email address or 10 digit mobile number.", passwordRequired: "Please enter your password.", loginFailed: "Login could not be completed. Please try again.",
      allowLocation: "Allow location access to mark attendance for this login.", savingAttendance: "Saving login attendance...", attendanceMarked: "Attendance marked at login.",
      verified: "Verified", logging: "Logging in as", at: "at", goDashboard: "Go to my dashboard", logoutHint: "To use another account, first log out from the dashboard.",
      recovery: "ACCOUNT RECOVERY", forgotCopy: "Verify your registered email with an OTP, then create a new password.", resetBadge: "SECURE PASSWORD RECOVERY", resetHeroOne: "Reset securely.", resetHeroTwo: "Get back in.", resetHeroCopy: "Verify your registered email with a one-time code and create a new password.",
      resetFlowOne: "Enter your account contact", resetFlowOneCopy: "Use your registered email or mobile number", resetFlowTwo: "Verify the reset OTP", resetFlowTwoCopy: "The code is sent to your registered email", resetFlowThree: "Create a new password", resetFlowThreeCopy: "Your new password is stored as a secure hash",
      sendResetOtp: "Send reset OTP", sendingResetOtp: "Sending OTP...", resetOtpSent: "Reset OTP sent to your registered email.", resetOtpFailed: "Password reset OTP could not be sent.",
      verifyReset: "VERIFY RESET", verifyResetOtp: "Verify OTP", enterResetOtp: "Enter the 6-digit OTP", resetOtpInfo: "We sent a password reset code to", otpCode: "OTP code", testingOtp: "Testing OTP:", expires: "Code expires in", verifying: "Verifying...", invalidOtp: "Invalid OTP.", otpVerified: "OTP verified successfully.", resendResetOtp: "Resend OTP", changeIdentifier: "Change email/mobile",
      createNewPassword: "Create a new password", newPasswordCopy: "Choose a password with at least 8 characters.", newPassword: "New password", confirmPassword: "Confirm password", passwordMin: "Password must be at least 8 characters.", passwordRules: "Password must be at least 8 characters and include a letter, a number, and a symbol.", passwordMismatch: "Passwords do not match.", savingPassword: "Saving password...", resetPassword: "Reset password", passwordResetFailed: "Password could not be updated.", passwordResetSuccess: "Password reset successfully.", passwordResetSuccessTitle: "Password updated", passwordResetSuccessCopy: "Your password has been changed successfully. You can now log in with your new password.", backToLogin: "Back to login",
    },
    hi: {
      securityBadge: "सरल, सुरक्षित, पासवर्ड लॉगिन",
      heroTitleOne: "एक सुरक्षित साइन-इन।", heroTitleTwo: "बिल्कुल बिना परेशानी।",
      heroCopy: "अपने registered email या mobile number और password से अपने काम पर वापस जाएं।",
      flowOneTitle: "Email या mobile दर्ज करें", flowOneCopy: "अपने account में saved contact का उपयोग करें",
      flowTwoTitle: "Password दर्ज करें", flowTwoCopy: "Password securely hash होकर save होता है",
      flowThreeTitle: "अपना workspace खोलें", flowThreeCopy: "जहां छोड़ा था वहीं से शुरू करें",
      privacyTitle: "आपकी गोपनीयता सबसे पहले", privacyCopy: "हर बार सुरक्षित access।",
      login: "लॉग इन", welcome: "वापसी पर स्वागत है", loginCopy: "अपने registered email/mobile और password से sign in करें।",
      identifier: "Email या mobile number", password: "Password", forgotPassword: "Password भूल गए?", loggingIn: "लॉग इन हो रहा है...",
      newUser: "KaamDesk पर नए हैं?", register: "अपनी कंपनी register करें", validIdentifier: "कृपया valid email या 10 digit mobile number दर्ज करें।", passwordRequired: "कृपया password दर्ज करें।", loginFailed: "Login पूरा नहीं हो सका। कृपया फिर कोशिश करें।",
      allowLocation: "इस login की attendance mark करने के लिए location access allow करें।", savingAttendance: "Login attendance save हो रही है...", attendanceMarked: "Login के समय attendance mark हो गई है।",
      verified: "सत्यापित", logging: "लॉग इन किया गया", at: "पर", goDashboard: "मेरा dashboard खोलें", logoutHint: "दूसरा account इस्तेमाल करने के लिए पहले dashboard से logout करें।",
      recovery: "ACCOUNT RECOVERY", forgotCopy: "अपने registered email पर OTP verify करें और फिर नया password बनाएं।", resetBadge: "सुरक्षित PASSWORD RECOVERY", resetHeroOne: "सुरक्षित तरीके से reset करें।", resetHeroTwo: "फिर से access पाएं।", resetHeroCopy: "Registered email पर one-time code verify करके नया password बनाएं।",
      resetFlowOne: "Account contact दर्ज करें", resetFlowOneCopy: "Registered email या mobile number इस्तेमाल करें", resetFlowTwo: "Reset OTP verify करें", resetFlowTwoCopy: "Code registered email पर भेजा जाएगा", resetFlowThree: "नया password बनाएं", resetFlowThreeCopy: "नया password secure hash के रूप में save होगा",
      sendResetOtp: "Reset OTP भेजें", sendingResetOtp: "OTP भेजा जा रहा है...", resetOtpSent: "Reset OTP registered email पर भेज दिया गया है।", resetOtpFailed: "Password reset OTP नहीं भेजा जा सका।",
      verifyReset: "RESET VERIFY", verifyResetOtp: "OTP verify करें", enterResetOtp: "6 अंकों का OTP दर्ज करें", resetOtpInfo: "Password reset code भेजा गया है", otpCode: "OTP code", testingOtp: "Testing OTP:", expires: "Code expires in", verifying: "Verify किया जा रहा है...", invalidOtp: "Invalid OTP।", otpVerified: "OTP successfully verify हो गया।", resendResetOtp: "OTP फिर भेजें", changeIdentifier: "Email/mobile बदलें",
      createNewPassword: "नया password बनाएं", newPasswordCopy: "कम से कम 8 characters का password चुनें।", newPassword: "नया password", confirmPassword: "Password confirm करें", passwordMin: "Password कम से कम 8 characters का होना चाहिए।", passwordRules: "Password में कम से कम 8 characters, एक letter, एक number और एक symbol होना चाहिए।", passwordMismatch: "Passwords match नहीं कर रहे।", savingPassword: "Password save हो रहा है...", resetPassword: "Password reset करें", passwordResetFailed: "Password update नहीं हो सका।", passwordResetSuccess: "Password successfully reset हो गया।", passwordResetSuccessTitle: "Password updated", passwordResetSuccessCopy: "आपका password successfully change हो गया है। अब नए password से login करें।", backToLogin: "Login पर वापस जाएं",
    }
  },
  registration: {
    en: {
      steps: [["Company information", "Name, type, city, owner details"], ["Verify your email", "Secure email OTP verification"], ["Choose a plan", "₹9 Pehchaan trial or paid"], ["Payment", "UPI, card or net banking"], ["Set up your company", "Department, hours and manager"]],
      trialTitle: "Pehchaan Trial — ₹9 for 30 days", trialCopy: "Full Growth features, no restrictions. Your team joins free — no per-seat charge during trial.",
      stepOne: "Step 1 of 5", companyTitle: "Tell us about your company", companyCopy: "You can always change these details later from your company settings.", languageLabel: "Language / भाषा", companyName: "Company name", companyRegistered: "(as registered)", businessType: "Business type", city: "City", selectType: "Select type", gstNumber: "GST number", gstHelp: "optional — needed for GST invoice", gstCopy: "Leave blank if you don't have a GST number. You can add it later.", password: "Password", passwordHelp: "Use at least 8 characters. This password will be securely hashed.", fullName: "Your full name", email: "Email address", mobile: "Your mobile number", mobileCopy: "This number becomes your login after email verification.", terms: "I agree to KaamDesk's Terms of Service and Privacy Policy", continueVerify: "Continue — Verify my email", sendingEmailOtp: "Sending email OTP..."
    },
    hi: {
      steps: [["कंपनी की जानकारी", "नाम, प्रकार, शहर और मालिक की जानकारी"], ["अपना ईमेल सत्यापित करें", "सुरक्षित ईमेल ओटीपी सत्यापन"], ["योजना चुनें", "₹9 पहचान ट्रायल या सशुल्क योजना"], ["भुगतान", "यूपीआई, कार्ड या नेट बैंकिंग"], ["कंपनी सेट करें", "विभाग, कार्य समय और प्रबंधक"]],
      trialTitle: "पहचान ट्रायल — 30 दिनों के लिए ₹9", trialCopy: "ग्रोथ प्लान की सभी सुविधाएं, बिना किसी रोक के। ट्रायल में टीम सदस्य मुफ्त जुड़ते हैं।",
      stepOne: "चरण 1 / 5", companyTitle: "अपनी कंपनी के बारे में बताएं", companyCopy: "इन विवरणों को आप बाद में कंपनी सेटिंग्स से बदल सकते हैं।", languageLabel: "भाषा", companyName: "कंपनी का नाम", companyRegistered: "(पंजीकरण के अनुसार)", businessType: "व्यवसाय का प्रकार", city: "शहर", selectType: "प्रकार चुनें", gstNumber: "जीएसटी नंबर", gstHelp: "वैकल्पिक — जीएसटी इनवॉइस के लिए आवश्यक", gstCopy: "यदि आपके पास जीएसटी नंबर नहीं है तो इसे खाली छोड़ दें। इसे बाद में जोड़ा जा सकता है।", password: "पासवर्ड", passwordHelp: "कम से कम 8 characters का password रखें। यह securely hash होकर save होगा।", fullName: "आपका पूरा नाम", email: "ईमेल पता", mobile: "आपका मोबाइल नंबर", mobileCopy: "ईमेल सत्यापन के बाद यही नंबर आपका लॉगिन बनेगा।", terms: "मैं KaamDesk की सेवा शर्तों और गोपनीयता नीति से सहमत हूं", continueVerify: "जारी रखें — मेरा ईमेल सत्यापित करें", sendingEmailOtp: "ईमेल ओटीपी भेजा जा रहा है..."
    }
  }
};

/* Common UI words make dynamic sentences bilingual without component-specific hacks. */
export const HI_WORD_TRANSLATIONS = Object.freeze({
  active: "सक्रिय",
  employee: "कर्मचारी",
  employees: "कर्मचारी",
  task: "कार्य",
  tasks: "कार्य",
  today: "आज",
  attendance: "उपस्थिति",
  leave: "अवकाश",
  request: "अनुरोध",
  requests: "अनुरोध",
  review: "समीक्षा",
  pending: "लंबित",
  completed: "पूर्ण",
  completion: "पूर्णता",
  progress: "प्रगति",
  verified: "सत्यापित",
  department: "विभाग",
  departments: "विभाग",
  team: "टीम",
  member: "सदस्य",
  members: "सदस्य",
  manager: "मैनेजर",
  managers: "मैनेजर",
  owner: "मालिक",
  role: "भूमिका",
  assign: "सौंपें",
  assigned: "सौंपा गया",
  add: "जोड़ें",
  send: "भेजें",
  export: "निर्यात",
  report: "रिपोर्ट",
  reports: "रिपोर्ट",
  billing: "बिलिंग",
  portal: "पोर्टल",
  plan: "प्लान",
  manage: "प्रबंधित करें",
  settings: "सेटिंग्स",
  notification: "सूचना",
  notifications: "सूचनाएं",
  announcement: "घोषणा",
  announcements: "घोषणाएं",
  action: "कार्रवाई",
  actions: "कार्रवाइयां",
  quick: "त्वरित",
  view: "देखें",
  all: "सभी",
  new: "नया",
  create: "बनाएं",
  update: "अपडेट करें",
  delete: "हटाएं",
  edit: "संपादित करें",
  save: "सहेजें",
  cancel: "रद्द करें",
  close: "बंद करें",
  open: "खोलें",
  submit: "जमा करें",
  search: "खोजें",
  filter: "फ़िल्टर",
  filters: "फ़िल्टर",
  select: "चुनें",
  status: "स्थिति",
  priority: "प्राथमिकता",
  project: "प्रोजेक्ट",
  date: "तिथि",
  from: "से",
  to: "तक",
  start: "शुरू",
  end: "समाप्त",
  reason: "कारण",
  details: "विवरण",
  description: "विवरण",
  title: "शीर्षक",
  name: "नाम",
  email: "ईमेल",
  mobile: "मोबाइल",
  phone: "फोन",
  address: "पता",
  city: "शहर",
  company: "कंपनी",
  companies: "कंपनियां",
  profile: "प्रोफाइल",
  language: "भाषा",
  english: "अंग्रेज़ी",
  hindi: "हिंदी",
  login: "लॉगिन",
  logout: "लॉगआउट",
  signup: "साइन अप",
  register: "पंजीकरण",
  password: "पासवर्ड",
  forgot: "भूल गए",
  reset: "रीसेट",
  loading: "लोड हो रहा है",
  error: "त्रुटि",
  success: "सफलता",
  message: "संदेश",
  messages: "संदेश",
  alert: "चेतावनी",
  warning: "चेतावनी",
  empty: "खाली",
  no: "कोई नहीं",
  yes: "हाँ",
  previous: "पिछला",
  next: "अगला",
  page: "पृष्ठ",
  records: "रिकॉर्ड",
  data: "डेटा",
  activity: "गतिविधि",
  recent: "हाल की",
  current: "वर्तमान",
  average: "औसत",
  total: "कुल",
  score: "स्कोर",
  performance: "प्रदर्शन",
  analytics: "विश्लेषण",
  present: "उपस्थित",
  absent: "अनुपस्थित",
  late: "देर",
  check: "जांच",
  in: "में",
  out: "बाहर",
  time: "समय",
  hours: "घंटे",
  day: "दिन",
  days: "दिन",
  week: "सप्ताह",
  month: "महीना",
  year: "वर्ष",
  amount: "राशि",
  payment: "भुगतान",
  invoice: "इनवॉइस",
  subscription: "सदस्यता",
  trial: "ट्रायल",
  source: "स्रोत",
  industry: "उद्योग",
  severity: "गंभीरता",
  bug: "बग",
  bugs: "बग्स",
  logs: "लॉग्स",
  platform: "प्लेटफ़ॉर्म",
  revenue: "राजस्व",
  growth: "वृद्धि",
  health: "स्वास्थ्य",
  users: "उपयोगकर्ता",
  admin: "एडमिन",
  super: "सुपर",
  note: "नोट",
  notes: "नोट्स",
  attachment: "संलग्नक",
  attachments: "संलग्नक",
  comment: "टिप्पणी",
  comments: "टिप्पणियां",
  apply: "आवेदन करें",
  approve: "स्वीकृत करें",
  reject: "अस्वीकृत करें",
  accepted: "स्वीकृत",
  rejected: "अस्वीकृत",
  available: "उपलब्ध",
  used: "उपयोग किया",
  done: "पूर्ण",
  optional: "वैकल्पिक",
  required: "आवश्यक",
  valid: "मान्य",
  invalid: "अमान्य",
  please: "कृपया",
  choose: "चुनें",
  continue: "आगे बढ़ें",
  back: "वापस",
  home: "होम",
  menu: "मेनू",
  navigation: "नेविगेशन",
  upload: "अपलोड",
  download: "डाउनलोड",
  refresh: "रीफ्रेश",
  retry: "पुनः प्रयास",
  read: "पढ़ा हुआ",
  mark: "चिह्नित करें",
  rate: "दर",
  snapshot: "सार",
  summary: "सारांश",
  generated: "तैयार",
  first: "पहला",
  last: "अंतिम",
  enabled: "सक्रिय",
  disabled: "निष्क्रिय",
  working: "कार्य",
  timezone: "समय क्षेत्र",
  format: "प्रारूप",
  currency: "मुद्रा",
  display: "प्रदर्शन",
  preferences: "प्राथमिकताएं",
  information: "जानकारी",
  type: "प्रकार",
});

export const SUPPORTED_LANGUAGES = Object.freeze({
  ENGLISH: "en",
  HINDI: "hi",
});
export const LANGUAGE_STORAGE_KEY = "kaamdesk_language";
